import React from 'react';
import { Button } from '../../../components/ui/Button/Button';
import {
  SuccessCard, SuccessTitle, SuccessInfoPanel, SuccessInfoRow, SuccessInfoLabel,
  SuccessInfoValue, SuccessNumero, SuccessMessage, SuccessButtonGroup
} from '../../../components/ui/SuccessCard/SuccessCard';
import { FaCheck, FaFileAlt, FaHome } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const SuccessScreen = ({ protocoloData, onNovoProtocolo }) => {
  const navigate = useNavigate();

  const handleVoltarHome = () => {
    navigate('/');
  };

  return (
    <SuccessCard>
      <SuccessTitle>
        <FaCheck style={{ marginRight: '0.5rem' }} />
        Protocolo Enviado com Sucesso!
      </SuccessTitle>

      <SuccessInfoPanel>
        <SuccessInfoRow>
          <SuccessInfoLabel>Nº do Protocolo:</SuccessInfoLabel>
          <SuccessNumero>{protocoloData?.numeroProtocolo || 'Gerado'}</SuccessNumero>
        </SuccessInfoRow>
        <SuccessInfoRow>
          <SuccessInfoLabel>Data de Emissão:</SuccessInfoLabel>
          <SuccessInfoValue>{new Date().toLocaleDateString('pt-BR')}</SuccessInfoValue>
        </SuccessInfoRow>
        <SuccessInfoRow>
          <SuccessInfoLabel>Horário:</SuccessInfoLabel>
          <SuccessInfoValue>{new Date().toLocaleTimeString('pt-BR')}</SuccessInfoValue>
        </SuccessInfoRow>
        <SuccessInfoRow>
          <SuccessInfoLabel>Status:</SuccessInfoLabel>
          <SuccessInfoValue $cor="#16a34a">✓ Enviado com sucesso</SuccessInfoValue>
        </SuccessInfoRow>
      </SuccessInfoPanel>

      <SuccessMessage>
        O requerimento foi registrado com sucesso. Acompanhe em "Minhas Solicitações".
      </SuccessMessage>

      <SuccessButtonGroup>
        <Button
          variant="secondary"
          onClick={() => window.location.href = '/solicitacoes'}
          leftIcon={<FaFileAlt />}
        >
          Ver Minhas Solicitações
        </Button>
        <Button
          variant="secondary"
          onClick={handleVoltarHome}
          leftIcon={<FaHome />}
        >
          Voltar para Home
        </Button>
        <Button
          variant="primary"
          onClick={onNovoProtocolo}
          leftIcon={<FaFileAlt />}
        >
          Novo Protocolo
        </Button>
      </SuccessButtonGroup>
    </SuccessCard>
  );
};

export default SuccessScreen;
